import { useState, useEffect } from 'react';

/**
 * Custom hook for password validation
 * Validates password against requirements:
 * - Minimum 12 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one number
 *
 * @param {string} password - The password to validate
 * @returns {Object} { validation, isValid, strength }
 */
export const usePasswordValidation = (password) => {
  const [validation, setValidation] = useState({
    minLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
  });

  useEffect(() => {
    setValidation({
      minLength: password.length >= 12,
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasNumber: /[0-9]/.test(password),
    });
  }, [password]);

  const isValid = Object.values(validation).every(Boolean);

  // Strength: count how many criteria are met (0-4)
  const strength = Object.values(validation).filter(Boolean).length;

  return { validation, isValid, strength };
};
